import React from 'react';
import { Clock, Target, Hash, BarChart3, Users, Calendar, TrendingUp } from 'lucide-react';
import { formatHours } from './utils/roundUtils';

const getIconColorClass = (color) => {
  const colorMap = {
    blue: 'text-blue-500',
    green: 'text-green-500',
    purple: 'text-purple-500',
    indigo: 'text-indigo-500',
    orange: 'text-orange-500',
    teal: 'text-teal-500',
    red: 'text-red-500',
    gray: 'text-gray-500',
  };
  return colorMap[color] || colorMap.gray;
};

const StatCard = ({ icon: Icon, label, value, color = 'gray' }) => (
  <div className="flex items-center space-x-2">
    <Icon className={`w-4 h-4 ${getIconColorClass(color)}`} />
    <div className="text-xs">
      <div className="text-gray-500 dark:text-slate-400">{label}</div>
      <div className="font-medium text-gray-900 dark:text-slate-100">{value}</div>
    </div>
  </div>
);

const GroupStatistics = ({ group }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 sm:gap-4 p-3 sm:p-4 bg-gray-50 dark:bg-slate-700/30 border-b border-gray-200 dark:border-white/10">
    <StatCard 
      icon={Clock} 
      label="Total Hours" 
      value={`${formatHours(group.totalHours)}h`}
      color="blue"
    />
    <StatCard 
      icon={Target} 
      label="Total Estimated" 
      value={`${formatHours(group.totalEstimated)}h`}
      color="green"
    />
    <StatCard 
      icon={Hash} 
      label="Log Entries" 
      value={group.totalEntries}
      color="purple"
    />
    <StatCard 
      icon={BarChart3} 
      label="Unique Issues" 
      value={group.uniqueIssuesCount}
      color="indigo"
    />
    <StatCard 
      icon={Users} 
      label="Team Members" 
      value={group.uniqueAuthors}
      color="orange"
    />
    <StatCard 
      icon={Calendar} 
      label="Work Days" 
      value={group.workDays}
      color="teal"
    />
    
    {/* Second row with efficiency metrics */}
    <StatCard 
      icon={TrendingUp} 
      label="Efficiency" 
      value={`${group.efficiency.toFixed(1)}%`}
      color={group.efficiency > 100 ? 'red' : 'green'}
    />
    <StatCard 
      icon={Clock} 
      label="Avg/Entry" 
      value={`${formatHours(group.avgHoursPerEntry)}h`}
      color="blue"
    />
    <StatCard 
      icon={Target} 
      label="Avg/Issue" 
      value={`${formatHours(group.avgHoursPerIssue)}h`}
      color="purple"
    />
    <StatCard 
      icon={BarChart3} 
      label="Variance" 
      value={`${group.variance > 0 ? '+' : ''}${formatHours(group.variance)}h`}
      color={group.variance > 0 ? 'red' : 'green'}
    />
    <StatCard 
      icon={Calendar} 
      label="Date Span" 
      value={`${group.dateSpan} days`}
      color="gray"
    />
    <StatCard 
      icon={Users} 
      label="Assignees" 
      value={group.uniqueAssignees}
      color="indigo"
    />
  </div>
);

export default GroupStatistics;

